import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  message = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {message: string},
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {
    if (data.message) {
      this.message = data.message;
    }
  }

  ngOnInit(): void {
  }

}